const FEATURES = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '全球 CDN 加速，高清动漫秒开不卡顿，观看体验流畅顺滑。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '电脑、手机、平板全平台支持，随时随地追番不受限。',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存',
    desc: '支持动漫离线下载，无网络也能畅享精彩内容。',
  },
  {
    icon: 'ri-closed-captioning-line',
    title: '多字幕组',
    desc: '聚合多个字幕组翻译资源，自由选择你喜欢的字幕版本。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    desc: '纯净观影环境，无弹窗广告骚扰，专注动漫本身。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500">为什么数百万动漫迷选择樱花动漫网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {FEATURES.map((item) => (
            <div
              key={item.title}
              className="text-center p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-secondary-300 transition-all duration-200"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-secondary-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-secondary-500`}></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}